module.exports = __webpack_public_path__ + "media/bg/bg-6-9ebaccb5.jpg";